import firebase from 'firebase'
// import piexif from 'piexifjs'

export default {
  data () {
    return {
      // uploadFiles: [],
      emailMaxLen: 9990,
      fileCount: 0,
      withoutAttachment: false,
      allDone: false,
      pressed: false,
      sendLoading: false
    }
  },

  created () {
  },

  mounted () {
  },

  computed: {
  },

  filters: {
  },

  watch: {
    // fileCount: function () {
    //   if (this.inData.attachments.length === this.fileCount) {
    //     this.setNewPost(this.makeObject())
    //   }
    // },

    withoutAttachment: function () {
      this.setNewPost(this.makeObject())
    },

    allDone: function () {
      this.sendLoading = false
      this.$ons.notification.toast('保存しました！', { timeout: 2000, animation: 'fall' })
      this.goBack()
    }
  },

  methods: {
    createDocId () {
      let categoryRef
      if (this.serviceType === 'scheduled') {
        categoryRef = firebase.firestore().collection('/scheduled')
      } else {
        categoryRef = firebase.firestore().collection('/users/' + this.user.userId + '/' + this.category)
      }
      this.inData.id = categoryRef.doc().id
    },

    sendEmailDirect () {
      const self = this
      const getNum = firebase.app().functions('asia-northeast1').httpsCallable('sendMail')
      const data = this.inData

      this.sendLoading = true
      getNum(data)
      .then((result) => {
        console.log('Send Email Succsess! ', result)
        self.sendLoading = false
      })
      .catch(function (err) {
        console.log('Error SendEmail: ', err)
        self.sendLoading = false
        self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
      })
    },

    selectFileMovie: function (e) {
      // ファイル選択はファイル一個だけの選択が前提
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      if (files.length > 1) {
        this.$ons.notification.alert('選択は一つだけにしてください！')
        e.target.files = []
        return
      }
      if (this.lic.movie > 2) {
        this.$ons.notification.alert('動画ファイルは３本までしか保存できません！')
        return
      }
      if (this.lic.role !== 'premium') {
        return
      }

      let f = files[0]

      const MB = 1024 * 1024
      const maxMB = 512
      const maxFileSize = MB * maxMB
      let obj = {name: f.name, size: f.size, url: ''}

      if (f.size > 0 && f.size < maxFileSize) {
        if (this.inData.movie === '') {
          this.inData.movie = obj
          this.uploadStorageMovie(f)
        } else {
          this.$ons.notification.alert('１メッセージにつき<br>動画は１つ添付可能です。<br>' + '別の動画を添付する場合は<br>現在の添付動画を削除してください。')
        }
      } else {
        this.$ons.notification.alert('ファイルサイズは<br>' + maxMB + 'MB以下にしてください。')
      }
    },

    uploadStorageMovie: function (file) {
      const self = this
      const storageRef = firebase.storage().ref()
      var uploadTask = storageRef.child('attachment/' +
        this.user.userId + '/' + this.category + '/' + this.inData.id + '/movie/' + file.name
      )
        .put(file)
        // .put(this.uploadFile)
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function (snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running')
              break
          }
        }, function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              console.log('User doesnt have permission to access the object')
              break

            case 'storage/canceled':
              console.log('User canceled the upload')
              break

            case 'storage/unknown':
              console.log('Unknown error occurred, inspect error.serverResponse')
              self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
              break

            default:
              console.log('Upload Error: ', error)
              self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
              break
          }
        }, function () {
        // Upload completed successfully, now we can get the download URL
        // どうしてもgetDownloadが成功するよりも前に、次の処理が走ってしまうので、downloadURLの取得が
        // 間に合わない。たぶん、クライアント側処理が終わってもサーバ側処理が終わってない模様。
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            // console.log('File available at', downloadURL)
            self.isEdit = true
            self.inData.movie.url = downloadURL
            self.incMovie()
          })
        })
    },

    selectFile: function (e) {
      // ファイル選択はファイル一個だけの選択が前提
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      if (files.length > 1) {
        this.$ons.notification.alert('選択は一つだけにしてください！')
        e.target.files = []
        return
      }
      let f = files[0]

      const MB = 1024 * 1024
      let maxMB = 0
      let maxFileSize = 0
      let maxFileNum = 0
      let obj = {name: f.name, size: f.size, url: ''}
      if (this.inData.type === 'email') {
        maxMB = 10
        maxFileNum = 4
      } else if (this.inData.type === 'twitter') {
        maxMB = 5
        if (this.inData.postType === 'tweet') {
          maxFileNum = 4
        } else { // dm
          maxFileNum = 1
        }
      }
      maxFileSize = MB * maxMB

      if (f.size > 0 && f.size < maxFileSize) {
        if (this.inData.attachments.length < maxFileNum) {
          this.inData.attachments.push(obj)
          this.uploadStorage(f, (this.inData.attachments.length - 1))
        } else {
          this.$ons.notification.alert('添付ファイルの数は<br>' + maxFileNum + '以下にしてください。')
        }
      } else {
        this.$ons.notification.alert('ファイルサイズは<br>' + maxMB + 'MB以下にしてください。')
      }
    },

    uploadStorage: function (file, index) {
      var self = this
      var storageRef = firebase.storage().ref()
      var uploadTask = storageRef.child('attachment/' +
        this.user.userId + '/' + this.category + '/' + this.inData.id + '/' + file.name
      )
        .put(file)
        // .put(this.uploadFile)
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function (snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running')
              break
          }
        }, function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              console.log('User doesnt have permission to access the object')
              break

            case 'storage/canceled':
              console.log('User canceled the upload')
              break

            case 'storage/unknown':
              console.log('Unknown error occurred, inspect error.serverResponse')
              self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
              break

            default:
              console.log('Upload Error: ', error)
              self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
              break
          }
        }, function () {
        // Upload completed successfully, now we can get the download URL
        // どうしてもgetDownloadが成功するよりも前に、次の処理が走ってしまうので、downloadURLの取得が
        // 間に合わない。たぶん、クライアント側処理が終わってもサーバ側処理が終わってない模様。
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            // console.log('File available at', downloadURL)
            self.isEdit = true
            self.inData.attachments[index].url = downloadURL
            // self.fileCount += 1
          })
        })
    },

    deleteAllAttachments () {
      const storageRef = firebase.storage().ref()

      if (this.inData.attachments.length > 0) {
        for (let i = 0; i < this.inData.attachments.length; i++) {
          storageRef.child('attachment/' +
            this.user.userId + '/' + this.category + '/' +
            this.inData.id + '/' + this.inData.attachments[i].name).delete()
            .then(function () {
              // File deleted successfully
              console.log('file deleted')
            }).catch(function (error) {
              // Uh-oh, an error occurred!
              console.log('file delete error', error)
            })
        }
      }
      this.deleteAttachmentMovie()
    },

    deleteMessage () {
      const self = this
      this.$options.buttonLabels = ['キャンセル', '続行']
      this.$ons.notification.confirm('本当に削除しますか？', this.$options)
        .then(response => {
          if (response > 0) {
            self.sendLoading = true
            self.pressed = true
            self.deleteMessageExe()
            if ((self.lic.triggered === 1) && (self.serviceType === 'messages')) {
              self.delReminder()
            }
          }
        })
    },

    deleteMessageExe () {
      const userRef = firebase.firestore().collection('/users').doc(this.user.userId)
      const triggerRef = userRef.collection('messages').doc(this.inData.id)
      const scheduledRef = firebase.firestore().collection('/scheduled').doc(this.inData.id)

      this.deleteAllAttachments()
      if (this.serviceType === 'scheduled') {
        scheduledRef.delete()
      } else {
        triggerRef.delete()
      }
      this.goBack()
    },

    createPostExec () {
      if (this.inDataCheck() === false) {
        return
      }

      const self = this
      this.$options.buttonLabels = ['キャンセル', '続行']
      this.$ons.notification.confirm('保存しますか？', this.$options)
        .then(response => {
          if (response > 0) {
            self.sendLoading = true
            self.pressed = true
            // self.inData.id = firebase.firestore().collection('/users/' + self.user.userId + '/' + self.category).doc().id
            // ファイルが選択されていたら、ファイルアップロード
            // if (self.inData.attachments.length > 0) {
              // for (let i = 0; i < self.inData.attachments.length; i++) {
              //   self.uploadStorage(self.uploadFiles[i], i)
              // }
            // } else {
            self.withoutAttachment = true
            // }
          }
        })
    },

    setNewPost: function (obj) {
      const self = this
      let categoryRef
      if (this.serviceType === 'messages') {
        categoryRef = firebase.firestore().collection('/users/' + this.user.userId + '/' + this.serviceType)
      } else { // scheduled
        categoryRef = firebase.firestore().collection('/scheduled')
      }

      // console.log('setNewPost')
      categoryRef.doc(this.inData.id).set(obj)
        .then(function () {
          if ((self.mode === 'create') && (self.serviceType === 'messages')) {
            self.updateReminder()
          }
          self.allDone = true
        })
        .catch((err) => {
          console.log('Error setNewPost!: ', err)
          self.sendLoading = false
          self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
        })
    },

    inDataCheck: function () {
      const maxContentEmail = this.emailMaxLen
      const maxContentTwitter = this.twitterMaxLen
      const maxContentTwitterDM = this.twitterDMmaxLen
      const maxNumTitle = 30
      const maxUserName = 32

      if (this.inData.type === '') {
        this.$ons.notification.alert('メッセージタイプを選択してください。')
        return false
      }
      if (this.inData.content.length === 0) {
        this.$ons.notification.alert('メッセージ内容を入力してください。')
        return
      }

      if (this.inData.type === 'twitter') {
        if (this.tweetType === 'dm') {
          if (this.isScreenNameDone === false) {
            this.$ons.notification.alert('DMを送るスクリーンネームを<br>確定してください。')
            return false
          }
          if (this.inData.content.length > maxContentTwitterDM) {
            this.$ons.notification.alert('文字数は　' + maxContentTwitterDM + '　以下にしてください。')
            return
          }
        } else {
          if (this.inData.content.length > maxContentTwitter) {
            this.$ons.notification.alert('文字数は　' + maxContentTwitter + '　以下にしてください。')
            return
          }
        }
      }

      if (this.inData.type === 'email') {
        this.inData.userName = this.inData.userName.replace(/\r|\n/g, '')
        if (this.inData.userName === '') {
          this.$ons.notification.alert('送信者名を入力してください！')
          return false
        }
        if (this.inData.userName.length > maxUserName) {
          this.$ons.notification.alert('送信者名は' + maxUserName + '文字以内にしてください。')
          return false
        }
        this.inData.title = this.inData.title.replace(/\r|\n/g, '')
        if (this.inData.title === '') {
          this.$ons.notification.alert('タイトルを入力してください。')
          return false
        }
        if (this.inData.title.length > maxNumTitle) {
          this.$ons.notification.alert('タイトルは' + maxNumTitle + '文字以内にしてください。')
          return false
        }
        if (this.inData.content.length > maxContentEmail) {
          this.$ons.notification.alert('内容が' + maxContentEmail + '文字を超えています。')
          return false
        }
      }

      if (this.inData.attachments.length > 0) {
        for (let i = 0; i < this.inData.attachments.length; i++) {
          if (this.inData.attachments[i].url === '') {
            this.$ons.notification.alert('添付ファイルのアップロードがまだ完了していません。')
            return false
          }
        }
      }

      if (this.serviceType === 'scheduled') {
        if (this.checkSelectableTerm(this.pickedDate) === false) {
          this.$ons.notification.alert('現在のプランによる指定可能な日付を超えています。')
          return false
        }
        if (this.checkPastDate(this.pickedDate)) {
          this.inData.targetDate = this.pickedDate
          this.inData.targetTimeStamp = this.convDateToTimeStamp(this.pickedDate)
        } else {
          this.$ons.notification.alert('送信日には未来の日付を設定してください。')
          return false
        }
      }

      // 作成日をセット
      this.inData.timeStamp = this.timestamp()
      // userIdをStoreからget
      this.inData.userId = this.user.userId
      this.inData.fromAddress = this.account.email

      return true
    },

    makeObject: function () {
      return this.inData
    },

    deleteAttachment (index) {
      const self = this

      if (this.inData.attachments.length > 0) {
        const storageRef = firebase.storage().ref()

        storageRef.child('attachment/' +
          this.user.userId + '/' + this.category + '/' +
          this.inData.id + '/' + this.inData.attachments[index].name).delete()
          .then(function () {
            // File deleted successfully
            self.inData.attachments.splice(index, 1)
            self.isEdit = true
            // this.uploadFiles.splice(index, 1)
            console.log('file deleted')
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log('file delete error', error)
          })
      }
    },
    deleteAttachmentMovie () {
      const self = this

      if (this.inData.movie) {
        const storageRef = firebase.storage().ref()

        storageRef.child('attachment/' +
          this.user.userId + '/' + this.category + '/' +
          this.inData.id + '/movie/' + this.inData.movie.name).delete()
          .then(function () {
            // File deleted successfully
            self.inData.movie = ''
            self.isEdit = true
            self.decMovie()
            console.log('movie deleted')
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log('movie delete error', error)
          })
      }
    },

    incMovie () {
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('incMovie')
      const data = {
        userId: this.account.uid
      }

      onCall(data)
      .then((result) => {
        // console.log('movie count up', result)
      })
      .catch((error) => {
        console.log('Error incMovie: ', error)
      })
    },
    decMovie () {
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('decMovie')
      const data = {
        userId: this.account.uid
      }

      onCall(data)
      .then((result) => {
        // console.log('movie count up', result)
      })
      .catch((error) => {
        console.log('Error incMovie: ', error)
      })
    },

    addAddress (mode) {
      const maxAddress = 100
      const maxName = 32
      const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/

      if (mode === 'to') {
        if (this.inData.toAddress.length < maxAddress) {
          if (this.toAddress.name.length > 0) {
            if (this.toAddress.name.length < maxName) {
              if (regexp.test(this.toAddress.address)) {
                this.inData.toAddress.push(this.toAddress)
                this.toAddress = {name: '', address: ''}
                this.dialogAddAddress = false
              } else {
                this.$ons.notification.alert('アドレス表記が正しくありません！')
              }
            } else {
              this.$ons.notification.alert('名前文字数の上限を超えています！')
            }
          } else {
            this.$ons.notification.alert('名前を入力してください！')
          }
        } else {
          this.$ons.notification.alert('アドレス設定数の上限を超えています！')
        }
      } else {
        if (this.inData.bccAddress.length < maxAddress) {
          if (this.bccAddress.name.length > 0) {
            if (this.bccAddress.name.length < maxName) {
              if (regexp.test(this.bccAddress.address)) {
                this.inData.bccAddress.push(this.bccAddress)
                this.bccAddress = {name: '', address: ''}
                this.dialogAddBcc = false
              } else {
                this.$ons.notification.alert('アドレス表記が正しくありません！')
              }
            } else {
              this.$ons.notification.alert('名前文字数の上限を超えています！')
            }
          } else {
            this.$ons.notification.alert('名前を入力してください！')
          }
        } else {
          this.$ons.notification.alert('アドレス設定数の上限を超えています！')
        }
      }
    },
    delAddress (index) {
      this.inData.toAddress.splice(index, 1)
    },
    delBcc (index) {
      this.inData.bccAddress.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_create.js